/*
 * @Descripttion:
 * @version:
 * @Author: tangshuo
 * @Date: 2022-08-26 11:37:41
 * @LastEditors: tangshuo
 * @LastEditTime: 2022-11-03 14:54:15
 */
import React, { FC, useState } from 'react';
import { FSDatePickerProps } from './interface';
import { MonthRender } from './MonthPicker';
import { DatePicker } from '@firesoon/antd';
import { DEFAULT_DATE } from './constants';
import moment from 'moment';
import './index.less';

const Index: FC<FSDatePickerProps> = ({
  disableFuture = true,
  showToday = false,
  monthCellFooterRender,
  renderExtraFooter,
  tipRender,
  style = {},
  ...rest
}) => {
  const [mode, setMode] = useState(DEFAULT_DATE);
  const footer = mode === DEFAULT_DATE ? { renderExtraFooter } : {};
  const defaultConfig = {
    // defaultValue: moment(),
    disabledDate(current) {
      return disableFuture ? current && current > moment() : false;
    },
    allowClear: false,
    monthCellContentRender: (current, locale) => MonthRender(monthCellFooterRender, tipRender, current, locale),
    onOpenChange: () => setMode(DEFAULT_DATE),
    onPanelChange: (_, type) => setMode(type),
    showToday,
    style: {
      width: 120,
      ...style,
    },
  };
  // ! 不管上层使用什么，都按此组件的来
  const importantConfig = {
    dropdownClassName: `fs-calendar-picker-container fs-monthpicker-not-default-render`,
  };

  return <DatePicker {...defaultConfig} {...footer} {...rest} {...importantConfig} />;
};

export default Index;
